import { Card, CardBody } from "reactstrap"

const WorkspaceStatCard = ({ title, value, subtitle, icon, color = "primary" }) => (
  <Card className="border-0 shadow-sm h-100">
    <CardBody className="d-flex justify-content-between gap-3">
      <div className="overflow-hidden">
        <div className="text-muted text-uppercase fw-semibold mb-1" style={{ fontSize: 11, letterSpacing: 0.8 }}>
          {title}
        </div>
        <div className="fw-bold text-dark" style={{ fontSize: 26, lineHeight: 1.1 }}>
          {value}
        </div>
        {subtitle && <div className="text-muted small mt-1">{subtitle}</div>}
      </div>
      <div className={`rounded-circle d-flex align-items-center justify-content-center bg-${color} bg-opacity-10 flex-shrink-0`} style={{ width: 52, height: 52 }}>
        <i className={`${icon} text-${color}`} style={{ fontSize: 22 }} />
      </div>
    </CardBody>
  </Card>
)

export default WorkspaceStatCard
